import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/mortgage-points',
  component: () => import('../../routes/MortgagePointsCalculator.svelte'),
  card: {
    id: 'mortgage-points',
    title: 'Mortgage Points Calculator',
    description: 'Compare mortgage rates with and without discount points to find the breakeven period and decide if buying points is worth it.',
    icon: 'home_work',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/mortgage-points',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Mortgage Points Calculator – Breakeven Analysis for Discount Points',
    description: 'Free mortgage points calculator to compare rates with and without discount points. Calculate your breakeven period and see if buying mortgage points makes financial sense for your situation.',
  },
};

export default meta;
